import { HttpContextToken } from '@angular/common/http';

export const SKIP_SPINNER_CONTEXT_TOKEN = new HttpContextToken<boolean>(() => false);
